module.exports = __webpack_public_path__ + "static/media/towerCrane.f12f2bce.png";